import { CoreIcon } from '../core-icon';
import mailSVG from '../../assets/icons/mail.svg';
import type { IconProps } from '../core-icon';

export const MailIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={mailSVG} {...props} />;
};
